<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        title="SpecAttr"
        :embedded="embedded"
        :height="height"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreComponent/SpecAttr/CoreSpecAttrDetail"
        :parent-component="$options.name"
        :main-validator="true"
        @alternate_action="$emit('alternate_action', $event)"
    >
      <template v-slot:item.dgs_status="{ item }">
        <v-icon v-if="item.dgs_status === 'success'" color="success">mdi-check-circle-outline</v-icon>
        <v-icon v-if="item.dgs_status === 'warning'" color="warning">mdi-alert-circle-outline</v-icon>
        <v-icon v-if="item.dgs_status === 'error'" color="error">mdi-alert-circle-outline</v-icon>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreSpecAttrDetail from "@/components/CoreComponent/SpecAttr/CoreSpecAttrDetail";
import {v4 as uuidv4} from "uuid";
import fileFunction from "@/commonFunction/fileFunction";

export default {
  name: "CoreSpecAttrTable",

  props: {
    embedded: {default: false},
    height: {default: null},
    storeName: {type: [String], default: 'SpecAttrTable'},
    dtoDetailQuery: {default: 'SpecAttrDetailQueryDTO'},
    detailStoreName: {default: 'SpecAttrDetail'},
    dtoValidateCommand: {type: [String], default: 'SpecAttrValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'SpecAttrListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'SpecAttrActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    CoreSpecAttrDetail,
  },

  methods: {
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.aggregateStore = useAggregateStore()
    this.storeTable.dtoDetailQuery = this.dtoDetailQuery
    this.storeTable.dtoListQuery = this.dtoListQuery
    this.storeTable.dtoActionCommand = this.dtoActionCommand
    this.storeTable.options.sortBy = ['group', 'name']
    this.storeTable.options.sortDesc = [true, true]
    this.storeTable.options.itemsPerPage = 100
    this.storeTable.headers = [
      // {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Group', value: 'group', sortable: true, filterable: true, divider: true,},
      {text: 'Name', value: 'name', sortable: false, divider: true},
      {text: 'Short name', value: 'short_name', sortable: true, divider: true, width: 60},
      {text: 'Units name', value: 'units_name', sortable: true, divider: true, width: 60},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
  },

  data() {
    return {
      storeTable: null,
      aggregateStore: null,
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>